<ng-container *ngIf="showComponent">
  <!-- Scroll anchor + hover events wrapper. #sentenceRoot gives us a ref for scrollIntoView. -->
  <div #sentenceRoot
       [class.sentence-is-active]="showAttentionBorder"
       [class.sentence-is-hovered]="showHoverCue"
       (mouseenter)="onSidebarMouseEnter()"
       (mouseleave)="onSidebarMouseLeave()">

  <!-- Header-only mode: render just the header without an expansion panel -->
  <ng-container *ngIf="panelSections === 'headerOnly'; else withPanel">
    <div class="sentence-suggestion-header">
      <mat-card-title (dblclick)="onDoubleClickPanel($event)">
        <p class="sentence-title" *ngIf="sentence.suggestion">{{ sentence.suggestion | censor }}</p>
        <p class="sentence-title" *ngIf="!sentence.suggestion">{{ sentence.input }}</p>
      </mat-card-title>

      <app-disclosure-controls
        [thisItemPath]="thisItemPath"
        [speakText]="sentence.suggestion || sentence.input"
        [readDefinitionWhenExpanded]="false"
        [expanded]="false"
        (requestReplace)="onMakeReplacement($event)"
      >
      </app-disclosure-controls>
    </div>
  </ng-container>

  <!-- Default / contentOnly / all modes -->
  <ng-template #withPanel>
    <mat-expansion-panel
      class="sentence-expansion-panel"
      [expanded]="panelOpenState"
      (opened)="onOpened()"
      (closed)="onClosed()"
      (afterExpand)="scrollToExpanded()"
    >
      <!-- HEADER -->
      <mat-expansion-panel-header *ngIf="panelSections === 'all' || panelSections === 'headerOnly'">
        <div class="sentence-header-container">
          <!-- TOP ROW -->
          <div class="sentence-header-row">
            <mat-card-title (dblclick)="onDoubleClickPanel($event)">
              <p class="sentence-title" *ngIf="sentence.suggestion">{{ sentence.suggestion | censor }}</p>
              <p class="sentence-title" *ngIf="!sentence.suggestion">{{ sentence.input }}</p>
            </mat-card-title>

            <app-disclosure-controls
              [thisItemPath]="thisItemPath"
              [speakText]="sentence.suggestion || sentence.input"
              [readDefinitionWhenExpanded]="false"
              [expanded]="panelOpenState"
              (requestReplace)="onMakeReplacement($event)"
            >
            </app-disclosure-controls>
          </div>

          <!-- FULL WIDTH SPINNER -->
          <mat-progress-bar
            mode="indeterminate"
            class="sentence-progress-bar"
            [class.is-hidden]="sentence.editState !== 'local'"
          >
          </mat-progress-bar>
        </div>
      </mat-expansion-panel-header>

      <!-- CONTENT -->
      <ng-container *ngIf="panelSections === 'all' || panelSections === 'contentOnly'">
        <ng-container class="sentence" *ngFor="let w of sentence.tokens; trackBy: trackByFn">
          <app-word [word]="w" [thisItemPath]="childItemPaths[w.index]" [elId]="elId"></app-word>
        </ng-container>
      </ng-container>
    </mat-expansion-panel>
  </ng-template>

  </div><!-- /#sentenceRoot -->
</ng-container>
